import React, { useState, useEffect, useContext } from "react"
import TextField from "@material-ui/core/TextField"
import Autocomplete from "@material-ui/lab/Autocomplete"
import CircularProgress from "@material-ui/core/CircularProgress"
import { Grid } from "@material-ui/core"
import Typography from "@material-ui/core/Typography"
import { X, ChevronDown } from "lucide-react"
import useStyles from "../../styles"
import { AuthContext } from "../../../../context/Auth/AuthContext"
import api from "../../../../services/api"
import toastError from "../../../../errors/toastError"

const WhatsappAutocomplete = ({ selectedWhatsapp, onWhatsappSelect }) => {
  const classes = useStyles()
  const [whatsapps, setWhatsapps] = useState([])
  const [loading, setLoading] = useState(false)
  const { user } = useContext(AuthContext)
  const { companyId, whatsappId } = user

  useEffect(() => {
    setLoading(true)
    const delayDebounceFn = setTimeout(() => {
      const fetchWhatsapps = async () => {
        try {
          const { data } = await api.get(`/whatsapp`, { params: { companyId, session: 0 } })
          setWhatsapps(data)
          setLoading(false)
        } catch (err) {
          setLoading(false)
          toastError(err)
        }
      }
      fetchWhatsapps()
    }, 500)

    return () => clearTimeout(delayDebounceFn)
  }, [companyId])

  useEffect(() => {
    if (whatsapps.length === 1) {
      onWhatsappSelect(whatsapps[0].id)
    }
  }, [whatsapps, onWhatsappSelect])

  // Definir whatsapp inicial se disponível
  useEffect(() => {
    if (whatsappId !== null && whatsappId !== undefined) {
      onWhatsappSelect(whatsappId)
    }
  }, [whatsappId, onWhatsappSelect])

  return (
    <Grid xs={12} item>
      <Autocomplete
        className={classes.autocomplete}
        required
        noOptionsText="Nenhuma conexão encontrada"
        value={whatsapps.find((w) => w.canalId === selectedWhatsapp) || null}
        onChange={(event, newValue) => {
          onWhatsappSelect(newValue ? newValue.canalId : "")
        }}
        popupIcon={<ChevronDown className={classes.iconChevronDown} strokeWidth={2.0} size={"24px"} />}
        closeIcon={<X className={classes.iconX} strokeWidth={2.0} size={"24px"} />}
        options={whatsapps}
        getOptionLabel={(option) => `${option.canal?.descricao || ""}`}
        getOptionSelected={(option, value) => option.canalId === value?.canalId}
        loading={loading}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Selecione uma Conexão"
            fullWidth
            required
            InputLabelProps={{
              classes: {
                root: classes.label,
              },
            }}
            InputProps={{
              ...params.InputProps,
              classes: { input: classes.textField },
              endAdornment: (
                <React.Fragment>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
        renderOption={(option, state) => {
          const statusClass = option.status === "CONNECTED" ? classes.online : classes.offline
          return (
            <div key={option.canalId}>
              <Typography
                component="span"
                style={{
                  fontSize: 14,
                  marginLeft: "10px",
                  display: "inline-flex",
                  alignItems: "center",
                  lineHeight: "2",
                }}
              >
                {option.canal?.descricao || ""} &nbsp;{" "}
                <span className={statusClass}>{option.status === "CONNECTED" ? "Conectado" : "Desconectado"}</span>
              </Typography>
            </div>
          )
        }}
      />
    </Grid>
  )
}
export default WhatsappAutocomplete
